import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { fetchLocations, deleteLocation } from '../../store/actions/location';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';

class Locations extends React.Component {
  state = {
    openModal: false,
    currentItem: null,
  };

  componentDidMount() {
    this.props.onFetchLocations();
  }

  handleDeleteClick = (item) => {
    this.setState({ openModal: true, currentItem: item });
  };

  handleDeleteCancel = () => {
    this.setState({ openModal: false, currentItem: null });
  };

  handleDeleteConfirm = () => {
    this.props.onDeleteLocation(this.state.currentItem.id);
    this.handleDeleteCancel();
  };

  render() {
    const { locations, loading, history } = this.props;

    const columns = [{ name: 'description', label: 'Descrição' }];

    const actions = [
      { name: 'Editar', icon: EditIcon, onClick: item => history.push(`/locais/${item.id}`) },
      { name: 'Excluir', icon: DeleteIcon, onClick: item => this.handleDeleteClick(item) },
    ];

    return (
      <React.Fragment>
        <ContentHeader
          title="Listagem de Locais"
          subtitle="Listagem com os locais cadastrados pela empresa"
        >
          <Button component={Link} to="/locais/cadastrar" variant="contained" color="primary">
            <AddIcon /> ADICIONAR
          </Button>
        </ContentHeader>

        <Paper elevation={2}>
          <DataTable rows={locations} columns={columns} actions={actions} loading={loading} />
        </Paper>

        <Dialog open={this.state.openModal} onClose={this.handleDeleteCancel}>
          <DialogTitle>Excluir local</DialogTitle>
          <DialogContent>
            <DialogContentText>Você tem certeza que deseja efetuar esta ação?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteCancel}>CANCELAR</Button>
            <Button onClick={this.handleDeleteConfirm} variant="contained" color="primary" autoFocus>
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  locations: state.location.locations,
});

const mapDispatchToProps = dispatch => ({
  onFetchLocations: () => dispatch(fetchLocations()),
  onDeleteLocation: id => dispatch(deleteLocation(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Locations);
